import { createSelector } from '@reduxjs/toolkit';

import { ProductionComponentInstance } from '@paragon/contract-library';

import { RootState } from '../store';
import { getProductionComponentInstancesByProductionGroupGuid } from './getProductionComponentInstancesByProductionGroupGuid';

export const getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTab = createSelector(
  getProductionComponentInstancesByProductionGroupGuid,
  (state: RootState) => state.batchesAndBundlesTab.activeProductionGroupGuid,

  (
    productionComponentInstancesByProductionGroupGuid,
    activeProductionGroupGuid,
  ): readonly ProductionComponentInstance[] =>
    activeProductionGroupGuid === null
      ? []
      : productionComponentInstancesByProductionGroupGuid[activeProductionGroupGuid],
);
